import React from 'react';

function CustomerVessels() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>My Vessels</h1>
        <p className="subtitle">Manage your registered boats</p>
      </div>
      <div className="empty-state">
        <p>Vessel management coming soon!</p>
      </div>
    </div>
  );
}

export default CustomerVessels;
